export default "__VITE_ASSET__Bork70TH__"